import React, { useEffect, useState } from "react";
import CourseDetail from "../components/course-detail";
import CourseList from "../components/course-list";
import ClassList from "../components/class-list";
import ClassDetail from "../components/class-detail";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import client from "../contentful";
import { doc, getDoc } from "firebase/firestore";

export default function Home() {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [courses, setCourses] = useState({});
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  const handleOnRefresh = () => {
    setCourses({});
    setRefresh((prev) => !prev);
  };

  const disableRightClick = (event) => {
    // event.preventDefault();
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const userRef = doc(db, "users", auth.currentUser.email);
        const userSnap = await getDoc(userRef);
        console.log(userSnap.data());

        if (userSnap.exists()) {
          const userData = userSnap.data();
          const courseIds = userData.courses || [];

          if (courseIds.length === 0) {
            setCourses({});
            return;
          }
          const courseEntries = await client.getEntries({
            content_type: "course",
            "sys.id[in]": courseIds.join(","),
          });

          const groupedCourses = {};

          courseEntries.items.forEach((courseEntry) => {
            const category = courseEntry?.fields?.category;
            const categoryName = category?.fields?.name ?? "Uncategorized";
            const categoryOrder = category?.fields?.order ?? 0;
            if (!groupedCourses[categoryName]) {
              groupedCourses[categoryName] = {
                order: categoryOrder,
                courses: [],
              };
            }
            groupedCourses[categoryName].courses.push(courseEntry);
          });
          console.log(groupedCourses);
          setCourses(groupedCourses || {});
        } else {
          setCourses({});
          return;
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [refresh]);

  useEffect(() => {
    const disableF12 = (event) => {
      if (event.keyCode === 123) {
        // KeyCode for F12
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", disableF12);

    return () => {
      window.removeEventListener("keydown", disableF12);
    };
  }, []);

  return (
    <div
      onContextMenu={disableRightClick}
      className="flex flex-col lg:flex-row h-screen gap-4 p-4"
    >
      {/* Left side for detailed content */}
      <div className="flex-1 flex-center gap-4">
        <div className="w-full flex flex-row h-12 items-center gap-4">
          <img
            onClick={() => {
              navigate("/");
            }}
            src="./assets/logo/app_without_text.png"
            alt="app logo"
            className="h-full cursor-pointer"
          />

          <h1 className="text-2xl font-bold text-nowrap title">
            JS Tradventures
          </h1>
          <div className="flex-1" />

          <div className="w-auto drawer drawer-end lg:hidden">
            <input id="my-drawer-4" type="checkbox" className="drawer-toggle" />
            <div className="drawer-content">
              <label
                htmlFor="my-drawer-4"
                className="drawer-button btn btn-square btn-ghost"
              >
                <Menu />
              </label>
            </div>
            <div className="drawer-side z-[500]">
              <label
                htmlFor="my-drawer-4"
                aria-label="close sidebar"
                className="drawer-overlay"
              ></label>
              <div className="menu bg-base-100 min-h-full w-80 h-full">
                <div className="w-full p-6 overflow-y-auto h-full flex flex-col justify-between ">
                  {Object.keys(courses).length < 1 ? (
                    <div className="flex-center  w-full h-full">
                      <div className="loading loading-md" />
                    </div>
                  ) : classes.length > 0 ? (
                    <ClassList
                      setClasses={setClasses}
                      classes={classes}
                      setSelectedClass={setSelectedClass}
                      selectedClass={selectedClass}
                    />
                  ) : (
                    <CourseList
                      onRefresh={handleOnRefresh}
                      courses={courses}
                      setClasses={setClasses}
                      setSelectedCourse={setSelectedCourse}
                      setSelectedClass={setSelectedClass}
                      selectedCourse={selectedCourse}
                    />
                  )}
                  <br />
                  <button
                    className="w-full btn btn-error btn-outline"
                    onClick={async () => {
                      await signOut(auth);
                      navigate("/login");
                    }}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h-full overflow-y-auto w-full">
          {!!selectedClass ? (
            <ClassDetail
              key={selectedClass.sys.id}
              selectedClass={selectedClass}
            />
          ) : !!selectedCourse ? (
            <CourseDetail course={selectedCourse} />
          ) : (
            <div className="flex justify-center md:justify-start flex-col items-center flex-1 h-full gap-4 p-4 pb-16">
              <div className="prose">
                <p className="font-bold text-center w-full">
                  DISCLAIMER/免责声明:
                </p>
                <ol className="list-decimal list-inside space-y-4">
                  <li className="font-bold">
                    Educational Purpose/教育用途声明:{" "}
                  </li>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>
                      The information provided in this trading class is for
                      educational purposes only and should not be construed as
                      financial advice. We do not provide investment, financial,
                      or trading advice. Any decisions made based on the
                      information provided in this class are at your own risk.
                    </li>
                    <li>
                      本交易课程所提供的所有信息仅供教育用途，不应被视为任何形式的财务建议。我们不提供投资、理财或交易建议。任何基于本课程信息所作出的决定，均由您自行承担风险。
                    </li>
                  </ul>
                  <li className="font-bold">Risk of Trading/交易风险声明:</li>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>
                      Trading in financial markets, including stocks, bonds,
                      options, futures, and cryptocurrencies, involves
                      substantial risk of loss and is not suitable for all
                      investors. Past performance is not indicative of future
                      results. You should carefully consider your financial
                      situation, investment objectives, risk tolerance, and
                      consult with a qualified financial advisor before engaging
                      in any trading activities.
                    </li>
                    <li>
                      金融市场的交易（包括股票、债券、期权、期货及加密货币）存在重大亏损风险，并非适合所有投资者。过往表现并不代表未来结果。在参与任何交易活动前，您应谨慎评估自身的财务状况、投资目标及风险承受能力，并咨询具资格的财务顾问。
                    </li>
                  </ul>
                  <li className="font-bold">No Guarantees/无保证声明:</li>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>
                      While we strive to provide accurate and timely
                      information, we make no guarantees regarding the accuracy,
                      completeness, or reliability of any information presented
                      in this class. The financial markets are inherently
                      unpredictable, and there is no assurance of success in
                      trading.
                    </li>
                    <li>
                      我们致力于提供准确与及时的信息，但无法保证本课程中所提供内容的准确性、完整性或可靠性。金融市场具有高度的不确定性，我们不对任何交易成功或盈利作出任何保证。
                    </li>
                  </ul>
                  <li className="font-bold">
                    Individual Responsibility/个人责任声明:
                  </li>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>
                      You are solely responsible for your trading decisions and
                      actions. We are not liable for any losses, damages, or
                      other consequences resulting from your reliance on the
                      information provided in this class or any trading
                      decisions you make.
                    </li>
                    <li>
                      您对自己的交易决定与行为负全责。我们不对因您依赖本课程内容或进行交易决策所导致的任何损失、损害或其他后果承担任何责任。
                    </li>
                  </ul>
                  <li className="font-bold">
                    Third-Party Links/第三方链接声明:
                  </li>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>
                      This class may contain links to third-party websites or
                      resources for informational purposes. We do not endorse or
                      control the content of these websites, and we are not
                      responsible for any information or services provided by
                      third parties.
                    </li>
                    <li>
                      本课程可能包含指向第三方网站或资源的链接，仅供信息参考。我们不对这些网站的内容或其提供的服务承担任何责任，也不代表我们对其进行任何认可或背书。
                    </li>
                  </ul>
                </ol>
                <p className="my-4 text-center font-semibold">
                  This includes but is not limited to: Securities Commission
                  Malaysia (SC), Monetary Authority of Singapore (MAS), U.S.
                  Securities and Exchange Commission (SEC), Financial Conduct
                  Authority UK (FCA), Australian Securities & Investments
                  Commission (ASIC), European Securities and Markets Authority
                  (ESMA), or any equivalent regulator worldwide.
                  马来西亚证券委员会（Securities Commission Malaysia,
                  SC）、新加坡金融管理局（Monetary Authority of Singapore,
                  MAS）、美国证券交易委员会（U.S. Securities and Exchange
                  Commission, SEC）、英国金融行为监管局（Financial Conduct
                  Authority, FCA）、澳大利亚证券与投资委员会（Australian
                  Securities & Investments Commission,
                  ASIC）、欧洲证券及市场管理局（European Securities and Markets
                  Authority, ESMA）及全球任何同等监管机构。
                </p>
              </div>
              <label
                htmlFor="my-drawer-4"
                className="drawer-button btn btn-outline lg:hidden w-full  absolute bottom-2 left-0 bg-white text-black"
              >
                Choose a Course to Continue
              </label>
            </div>
          )}
        </div>
      </div>

      {/* Right side for the list */}
      <div className="w-[calc(100% - 1rem)] hidden lg:flex lg:w-3/12 flex-col gap-4">
        <div className="border w-full p-6 lg:overflow-y-auto h-full">
          {/* + "max-h-52 lg:max-h-none h-full" */}
          {courses.length < 1 ? (
            <div className="flex-center w-full h-full">
              <div className="loading loading-md" />
            </div>
          ) : classes.length > 0 ? (
            <ClassList
              setClasses={setClasses}
              classes={classes}
              setSelectedClass={setSelectedClass}
              selectedClass={selectedClass}
            />
          ) : (
            <CourseList
              onRefresh={handleOnRefresh}
              courses={courses}
              setClasses={setClasses}
              setSelectedCourse={setSelectedCourse}
              setSelectedClass={setSelectedClass}
              selectedCourse={selectedCourse}
            />
          )}
        </div>
        <button
          className="w-full btn btn-error btn-outline"
          onClick={async () => {
            await signOut(auth);
            navigate("/login");
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
